import GoalView from './GoalView'

export default GoalView
